import { forwardRef } from 'react'
import type ReactTooltip from 'react-tooltip'
import { useTheme } from '@xstyled/styled-components'
import { StyledReactTooltip } from './Tooltip.styles'
import { makeOffset } from './utils'

export interface TooltipProps
  extends Pick<
    ReactTooltip['props'],
    | 'children'
    | 'id'
    | 'place'
    | 'clickable'
    | 'effect'
    | 'getContent'
    | 'overridePosition'
    | 'multiline'
  > {
  offset?: number
}

export const Tooltip = forwardRef<ReactTooltip, TooltipProps>(
  (props, ref): JSX.Element => {
    const theme = useTheme()

    return (
      <StyledReactTooltip
        ref={ref}
        effect={props.effect || 'solid'}
        textColor={theme.colors.white}
        backgroundColor={theme.colors.black}
        id={props.id}
        offset={makeOffset(props.offset)}
        overridePosition={props.overridePosition}
        getContent={props.getContent}
        multiline={props.multiline}
      >
        {props.children}
      </StyledReactTooltip>
    )
  }
)
